export default __webpack_public_path__ + "images/NS.d1d4128.png";